import { Avatar, Box, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import moment from 'moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import axios from 'axios';
import { styled } from '@mui/material/styles';

import { useResponsiveStyles } from '../../../utils/responsiveStyles';
import palette from '../../../theme/palette';
import Key from '../../../clientVariables.json';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.grey[600],
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));



function createData(name, v1, v2, v3) {
  return { name, v1, v2, v3 };
}
function createDataHistory(name, amount, transactionId, transactionStatus, invoiceNumber, Date) {
  return { name, amount, transactionId, transactionStatus, invoiceNumber, Date };
}

const Package = ({ customerDetailsData }) => {
  const styles = useResponsiveStyles();
  const [daysRemaining, setDaysRemaining] = useState(0);
  const [paymentList, setPaymentList] = useState(null);
  const [paymentHistoryRows, setPaymentHistoryRows] = useState(null);

  useEffect(() => {
    getPaymentList();
    const calculateDaysRemaining = (start, end) => {
      const today = moment();

      // Ensure start and end are valid moment objects
      const startMoment = moment(start);
      const endMoment = moment(end);

      if (!startMoment.isValid() || !endMoment.isValid()) {
        console.error('Invalid date(s) provided');
        return 0;
      }

      const duration = moment.duration(endMoment.diff(today));
      const daysRemaining = duration.asDays();

      return Math.ceil(daysRemaining);
    };

    setDaysRemaining(calculateDaysRemaining(customerDetailsData?.packageDetails?.package_start_date, customerDetailsData?.packageDetails?.package_end_date));
  }, [customerDetailsData]);

  const rows = [
    createData(
      'Plan',
      customerDetailsData?.packageDetails?.plan,
      moment(customerDetailsData?.packageDetails?.package_start_date).format('LL'),
      `${daysRemaining} days left`
      // moment(customerDetailsData?.packageDetails?.package_end_date).format('LL')
    ),
    createData('Jobs Allowed', 'Unlimited', customerDetailsData?.packageDetails?.jobsposted, 'Unlimited'),
    createData(
      'Resumes Views Allowed',
      customerDetailsData?.packageDetails?.resumeviews_allowed,
      customerDetailsData?.packageDetails?.resumesviewed,
      `${customerDetailsData?.packageDetails?.resumeviews_allowed && customerDetailsData?.packageDetails?.resumesviewed
        ? parseInt(customerDetailsData?.packageDetails?.resumeviews_allowed, 10) - parseInt(customerDetailsData?.packageDetails?.resumesviewed, 10)
        : parseInt(customerDetailsData?.packageDetails?.resumeviews_allowed, 10)} views left`
    ),
    createData(
      'Users',
      customerDetailsData?.packageDetails?.users_allowed,
      customerDetailsData?.packageDetails?.usersCreated,
     `${ customerDetailsData?.packageDetails?.usersCreated && customerDetailsData?.packageDetails?.users_allowed
      ? parseInt(customerDetailsData?.packageDetails?.users_allowed, 10) - parseInt(customerDetailsData?.packageDetails?.usersCreated, 10)
      : parseInt(customerDetailsData?.packageDetails?.users_allowed, 10)} users left`
    ),
  ];


  createDataHistory(paymentList?.title, paymentList?.title, paymentList?.title, paymentList?.title, paymentList?.title, paymentList?.title)

  // function daysRemaining(date) {
  //   const expiryDate = moment(date).startOf('day');
  //   const todaysDate = moment().startOf('day');
  //   return expiryDate.diff(todaysDate, 'days');
  // }

  const getPaymentList = async() => {
    try {
      const response = await axios.post(`${Key.domain}/customer/get_cust_payment_details`, {
        customer_id : customerDetailsData?.userDetails?.id
      });
      if(response.status === 200){
        // console.log(response.data.data);
        const data = response.data.data;
        setPaymentList(data); 
        const rowData = data.map((item) => 
            createDataHistory(
                item.title, 
                item.amount, 
                item.transaction_id, 
                item.transaction_status, 
                item.invoice_no, 
                moment(item.created).format('LL')
            )
        );
        setPaymentHistoryRows(rowData);

       
      }
    } catch (error) {
      console.error(error);
    }

  }


  const boxListStyles = {
    display: 'flex',
    gap: '20px',
    p: '10px',
  };

  const text1Styles = {
    m: 0,
    fontSize: styles.fontSize12,
    fontWeight: 500,
    color: palette.grey[800],
    textTransform: 'capitalize',
  };

  const iconStyles = {
    fontSize: styles.icon20,
    color: palette.grey[500],
  };
  const listItemGridStyles = {
    borderBottom: `1px solid ${palette.grey[200]}`,
    p: '5px',
  };
  const listItemGridContainerStyles = {
    alignItems: 'center',
  };
  // const box1Styles = {display:'flex', gap:'16px', p:'10px'}

  return (
    <div style={{ padding: '10px' }}>
      <TableContainer component={Paper} elevation={4}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
          <TableHead>
            <StyledTableRow>
              <StyledTableCell>Features</StyledTableCell>
              <StyledTableCell align="left">Selected Plan</StyledTableCell>
              <StyledTableCell align="left">Current Plan</StyledTableCell>
              <StyledTableCell align="left">Remaining Plan</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <StyledTableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <StyledTableCell component="th" scope="row">
                  {row.name}
                </StyledTableCell>
                <StyledTableCell align="left">{row.v1}</StyledTableCell>
                <StyledTableCell align="left">{row.v2}</StyledTableCell>
                <StyledTableCell align="left">{row.v3}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{marginTop:'10px'}}>
      <TableContainer component={Paper} elevation={4}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
          <TableHead>
            <StyledTableRow>
              <StyledTableCell>Plan</StyledTableCell>
              <StyledTableCell align="left">Amount</StyledTableCell>
              <StyledTableCell align="left">Transaction ID</StyledTableCell>
              <StyledTableCell align="left">Transaction Status</StyledTableCell>
              <StyledTableCell align="left">Invoice</StyledTableCell>
              <StyledTableCell align="left">Date</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {paymentHistoryRows?.map((row) => (
              <StyledTableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <StyledTableCell component="th" scope="row">
                  {row.name}
                </StyledTableCell>
                <StyledTableCell align="left">{row.amount}</StyledTableCell>
                <StyledTableCell align="left">{row.transactionId}</StyledTableCell>
                <StyledTableCell align="left">{row.transactionStatus}</StyledTableCell>
                <StyledTableCell align="left">{row.invoiceNumber}</StyledTableCell>
                <StyledTableCell align="left">{row.Date}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      </div>
    </div>
    //     <div>
    //       <Accordion defaultExpanded>
    //         <AccordionSummary
    //           expandIcon={<ExpandMoreIcon />}
    //           aria-controls="panel1-content"
    //           id="panel1-header"
    //         >
    //           <Typography>Selected Plan</Typography>
    //         </AccordionSummary>
    //         <AccordionDetails>
    //           <Grid container spacing={0}>
    //           <Grid item xs={12} sx={listItemGridStyles}>
    //             <Grid container spacing={0}>
    //               <Grid item xs={4}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 Plan Opted
    //               </Typography>
    //               </Grid>
    //               <Grid item xs={8}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 :&nbsp;&nbsp;&nbsp;
    //               {customerDetailsData?.packageDetails?.plan} plan
    //               </Typography>
    //               </Grid>
    //             </Grid>
    //             </Grid>
    //             <Grid item xs={12} sx={listItemGridStyles}>
    //             <Grid container spacing={0}>
    //               <Grid item xs={4}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 Jobs Allowed
    //               </Typography>
    //               </Grid>
    //               <Grid item xs={8}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 :&nbsp;&nbsp;&nbsp;
    //               Unlimited
    //               </Typography>
    //               </Grid>
    //             </Grid>
    //             </Grid>
    //             <Grid item xs={12} sx={listItemGridStyles}>
    //             <Grid container spacing={0}>
    //               <Grid item xs={4}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 Resumes Views Allowed
    //               </Typography>
    //               </Grid>
    //               <Grid item xs={8}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 :&nbsp;&nbsp;&nbsp;
    //               {customerDetailsData?.packageDetails?.resumeviews_allowed}
    //               </Typography>
    //               </Grid>
    //             </Grid>
    //             </Grid>
    //             <Grid item xs={12} sx={listItemGridStyles}>
    //             <Grid container spacing={0}>
    //               <Grid item xs={4}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 Users Allowed
    //               </Typography>
    //               </Grid>
    //               <Grid item xs={8}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 :&nbsp;&nbsp;&nbsp;
    //               {customerDetailsData?.packageDetails?.users_allowed}
    //               </Typography>
    //               </Grid>
    //             </Grid>
    //             </Grid>

    //           </Grid>
    //         </AccordionDetails>
    //       </Accordion>
    //       <Accordion>
    //         <AccordionSummary
    //           expandIcon={<ExpandMoreIcon />}
    //           aria-controls="panel2-content"
    //           id="panel2-header"
    //         >
    //           <Typography>Current Plan</Typography>
    //         </AccordionSummary>
    //         <AccordionDetails>
    //         <Grid container spacing={0}>
    //           <Grid item xs={12} sx={listItemGridStyles}>
    //             <Grid container spacing={0}>
    //               <Grid item xs={4}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //               Benefits Active From
    //               </Typography>
    //               </Grid>
    //               <Grid item xs={8}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 :&nbsp;&nbsp;&nbsp;
    //               {moment(customerDetailsData?.packageDetails?.package_start_date).format('LL')}
    //               </Typography>
    //               </Grid>
    //             </Grid>
    //             </Grid>
    //             <Grid item xs={12} sx={listItemGridStyles}>
    //             <Grid container spacing={0}>
    //               <Grid item xs={4}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //               Jobs Posted
    //               </Typography>
    //               </Grid>
    //               <Grid item xs={8}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 :&nbsp;&nbsp;&nbsp;
    //                 {customerDetailsData?.packageDetails?.jobsposted}
    //               </Typography>
    //               </Grid>
    //             </Grid>
    //             </Grid>
    //             <Grid item xs={12} sx={listItemGridStyles}>
    //             <Grid container spacing={0}>
    //               <Grid item xs={4}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //               Resumes Viewed
    //               </Typography>
    //               </Grid>
    //               <Grid item xs={8}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 :&nbsp;&nbsp;&nbsp;
    //               {customerDetailsData?.packageDetails?.resumesviewed}
    //               </Typography>
    //               </Grid>
    //             </Grid>
    //             </Grid>
    //             <Grid item xs={12} sx={listItemGridStyles}>
    //             <Grid container spacing={0}>
    //               <Grid item xs={4}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 Users Added
    //               </Typography>
    //               </Grid>
    //               <Grid item xs={8}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 :&nbsp;&nbsp;&nbsp;
    //               {customerDetailsData?.packageDetails?.usersCreated}
    //               </Typography>
    //               </Grid>
    //             </Grid>
    //             </Grid>

    //           </Grid>
    //         </AccordionDetails>
    //       </Accordion>
    //       <Accordion>
    //         <AccordionSummary
    //           expandIcon={<ExpandMoreIcon />}
    //           aria-controls="panel3-content"
    //           id="panel3-header"
    //         >
    //           <Typography>Remaining Plan</Typography>
    //         </AccordionSummary>
    //         <AccordionDetails>
    //         <Grid container spacing={0}>
    //           <Grid item xs={12} sx={listItemGridStyles}>
    //             <Grid container spacing={0}>
    //               <Grid item xs={4}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //               Benefits Expires On
    //               </Typography>
    //               </Grid>
    //               <Grid item xs={8}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 :&nbsp;&nbsp;&nbsp;
    //               {moment(customerDetailsData?.packageDetails?.package_end_date).format('LL')}
    //               </Typography>
    //               </Grid>
    //             </Grid>
    //             </Grid>
    //             <Grid item xs={12} sx={listItemGridStyles}>
    //             <Grid container spacing={0}>
    //               <Grid item xs={4}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //               Jobs Posts Left
    //               </Typography>
    //               </Grid>
    //               <Grid item xs={8}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 :&nbsp;&nbsp;&nbsp;Unlimited
    //               </Typography>
    //               </Grid>
    //             </Grid>
    //             </Grid>
    //             <Grid item xs={12} sx={listItemGridStyles}>
    //             <Grid container spacing={0}>
    //               <Grid item xs={4}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //               Resume Views Left
    //               </Typography>
    //               </Grid>
    //               <Grid item xs={8}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 :&nbsp;&nbsp;&nbsp;
    //               {customerDetailsData?.packageDetails?.resumeviews_allowed &&
    //               customerDetailsData?.packageDetails?.resumesviewed ? customerDetailsData?.packageDetails?.resumeviews_allowed - customerDetailsData?.packageDetails?.resumesviewed : 'N/A'
    // }
    //               </Typography>
    //               </Grid>
    //             </Grid>
    //             </Grid>
    //             <Grid item xs={12} sx={listItemGridStyles}>
    //             <Grid container spacing={0}>
    //               <Grid item xs={4}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //               Users Left to Add
    //               </Typography>
    //               </Grid>
    //               <Grid item xs={8}>
    //               <Typography paragraph sx={{ ...text1Styles }}>
    //                 :&nbsp;&nbsp;&nbsp;
    //                 {customerDetailsData?.packageDetails?.usersCreated &&
    //               customerDetailsData?.packageDetails?.users_allowed ? customerDetailsData?.packageDetails?.users_allowed - customerDetailsData?.packageDetails?.usersCreated : 'N/A'
    // }
    //               </Typography>
    //               </Grid>
    //             </Grid>
    //             </Grid>

    //           </Grid>
    //         </AccordionDetails>
    //       </Accordion>
    //     </div>
  );
};

export default Package;
